import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Button } from '@storable/canaveral-components';
import cx from 'classnames';
import ApplyButton from '../../../../modules/react/components/stateless/Button';
import styles from './PayOnlineEntryFilter.scss';
import Icon from '../../../../modules/react/components/stateless/Icon';
import PlaceholderIcon from '../../../../modules/react/components/stateless/PlaceholderIcon';
import PayOnlineStateFilter from '../PayOnlineStateFilter';

const PayOnlineEntryFilter = ({ expandAllPanels,
  collapseAllPanels,
  onSearchAndFilter,
  sortedStates,
  sortedFacilities,
  allPanelsExpanded,
  allPanelsCollapsed,
  stateFullNames }) => {
  const [searchText, setSearchText] = useState('');
  const [selectedStates, setSelectedStates] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [showFilterContainer, setShowFilterContainer] = useState(false);
  const [shouldResetStateFilter, setShouldResetStateFilter] = useState(false);

  useEffect(() => {
    if (shouldResetStateFilter) {
      setShouldResetStateFilter(false);
    }
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth <= 767);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [shouldResetStateFilter]);

  const escapeRegExp = text => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

  const filterFacilities = () => {
    const text = searchText.trim();
    let filteredResults = sortedFacilities;

    if (text.length <= 2 && selectedStates.length === 0) {
      setIsFilterApplied(false);
      return onSearchAndFilter(null);
    }

    setIsFilterApplied(true);

    if (selectedStates.length > 0) {
      filteredResults = filteredResults.filter(facility => selectedStates
        .includes(facility.address.stateFullName));
    }

    if (text.length > 2) {
      const escapedText = escapeRegExp(text);
      const regex = new RegExp(escapedText, 'i');
      filteredResults = filteredResults.filter((facility) => {
        const facilityText = facility.address.address1
            + facility.displayName
            + facility.address.postal
            + facility.address.city
            + facility.address.state
            + facility.address.stateFullName;
        return regex.test(facilityText);
      });
    }

    return onSearchAndFilter(filteredResults);
  };

  useEffect(() => {
    filterFacilities();
  }, [selectedStates, searchText]);

  const handleSearch = ({ target: { value } }) => {
    setSearchText(value);
  };

  const handleSearchKeyDown = (event) => {
    if (event.nativeEvent.keyCode === 13) {
      filterFacilities();
    }
  };

  const handleStateSelect = (selected) => {
    setSelectedStates(selected);
  };

  const filterResetHandler = () => {
    setSearchText('');
    setSelectedStates([]);
    onSearchAndFilter(null);
    setShouldResetStateFilter(true);
  };

  const handlerShowFilterContainer = () => {
    setShowFilterContainer(prev => !prev);
  };

  return (
    <div className={styles.mainContainer}>
     <div className={styles.filterButtonContainer}>
     <div className={styles.filterRow}>
     <span className={styles.facilityText}>FACILITY</span>
     <button type="button" className={styles.filterButton} onClick={handlerShowFilterContainer}>
     <div className={styles.filterButtonContent}>
      Filter / Search
      <PlaceholderIcon.FilterIcon className={styles.icon} />
     </div>
     </button>
     </div>
     <hr className={styles.divider} />
     </div>
     {(showFilterContainer || !isMobileScreen) && (
     <div className={`${styles.filterContainer} ${!showFilterContainer && styles.filterContainerInvisibleMobile}`}>
     {(isMobileScreen)
         && (
          <span className={styles.filterByText}>Filter By</span>
         )}
     <div className={styles.row}>
      <div className={styles.searchBar}>
        <Form.Control
          id="facility-search-input"
          type="text"
          onChange={handleSearch}
          onKeyDown={handleSearchKeyDown}
          placeholder="Search"
          value={searchText}
          data-testid="facility-search-input"
        />
        <Button
          context="bare"
          label="search"
          className={cx(styles.searchButton)}
          onClick={handleSearch}
          value={searchText}
        >
          <Icon
            id="search"
            label="searchIcon"
          />
        </Button>
      </div>
        <PayOnlineStateFilter
          options={stateFullNames}
          onSelect={handleStateSelect}
          selectedOptions={selectedStates}
          isMobileScreen={isMobileScreen}
          shouldResetStateFilter={shouldResetStateFilter}
        />
        <button type="button" className={styles.resetFilterButton} onClick={filterResetHandler}>Reset Filters</button>
     </div>
        <button type="button" className={`${styles.expandCollapseButton} ${allPanelsExpanded ? styles.greyedOut : ''}`} onClick={expandAllPanels}>Expand All</button>
        <span className={styles.pipe}>|</span>
        <button type="button" className={`${styles.expandCollapseButton} ${allPanelsCollapsed ? styles.greyedOut : ''}`} onClick={() => collapseAllPanels(sortedStates)}>Collapse All</button>
        {(isMobileScreen)
         && (
          <div className={styles.applyButton}>
          <ApplyButton
            block
            variant="primary"
            onClick={handlerShowFilterContainer}
            rel="noopener noreferrer"
            className="color-secondary-background color-primary-background-hover button-style-class"
          >
        {isFilterApplied ? 'APPLY' : 'CLOSE'}
          </ApplyButton>
          </div>
         )}
     {(!isMobileScreen)
         && (<hr className={styles.divider} />)}
     </div>
     )
     }
    </div>
  );
};

export default PayOnlineEntryFilter;
